import { render, staticRenderFns } from "./AdminSubjectsEditView.vue?vue&type=template&id=d0612d46"
import script from "./AdminSubjectsEditView.vue?vue&type=script&lang=js"
export * from "./AdminSubjectsEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports